import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutContent, statsData } from '@/mocks/homeData';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100/50 border-b border-background-200/70">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mt-2">关于我们</h1>
            <p className="text-sm text-foreground-600 mt-2">了解番茄视频的品牌故事与使命</p>
          </div>
        </div>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[800px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">品牌介绍</h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              {aboutContent.brandIntro}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
              我们的使命：<strong className="text-primary-600">{aboutContent.mission}</strong>
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-12">
              <div className="bg-background-100 rounded-xl p-4 md:p-5 text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{statsData.totalVideos}</div>
                <div className="text-xs text-foreground-500 mt-1">视频总量</div>
              </div>
              <div className="bg-background-100 rounded-xl p-4 md:p-5 text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{statsData.dailyViews}</div>
                <div className="text-xs text-foreground-500 mt-1">日播放量</div>
              </div>
              <div className="bg-background-100 rounded-xl p-4 md:p-5 text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{statsData.totalUsers}</div>
                <div className="text-xs text-foreground-500 mt-1">累计用户</div>
              </div>
              <div className="bg-background-100 rounded-xl p-4 md:p-5 text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{statsData.categoriesCount}</div>
                <div className="text-xs text-foreground-500 mt-1">内容分类</div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100/50 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-[800px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-8 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                {aboutContent.reputation.map((item) => (
                  <div key={item.title} className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-[800px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-8 text-center">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 font-heading">电子邮箱</h3>
                  <p className="text-xs text-foreground-500">{aboutContent.contact.email}</p>
                </div>
                <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 font-heading">客服电话</h3>
                  <p className="text-xs text-foreground-500">{aboutContent.contact.phone}</p>
                </div>
                <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 font-heading">公司地址</h3>
                  <p className="text-xs text-foreground-500">{aboutContent.contact.address}</p>
                </div>
                <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 font-heading">官方微信</h3>
                  <p className="text-xs text-foreground-500">{aboutContent.contact.wechat}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}